import { Component, OnInit } from "@angular/core";
import { AggregateBindingObject, ChartConfigSansData } from "@tylertech/aggregates-module";
import { ICustomViewComponent } from "@tylertech/custom-view";
import { AggregateCriteria, IAggregate } from "@tylertech/tyler-api-types";
import { TooltipItem } from "chart.js";

@Component({
    selector: "project-accounting-projects-nearing-budget-limit",
    templateUrl: "./projectsNearingBudgetLimit.tmpl.html",
    styleUrls: [
        "./projectsNearingBudgetLimit.component.scss"
    ],
    standalone: false
})
export class ProjectAccountingProjectsNearingBudgetLimitComponent implements OnInit, ICustomViewComponent<AggregateBindingObject>
{
    readonly customDataBinding: AggregateBindingObject;
    get aggregate(): IAggregate { return this.customDataBinding?.aggregate; }
    get aggregateCriteria(): AggregateCriteria { return this.customDataBinding?.aggregateCriteria; }

    chartConfiguration: ChartConfigSansData<"bar">;
    ngOnInit(): void
    {
        this.chartConfiguration = {
            type: "bar",
            options: {
                responsive: true,
                maintainAspectRatio: false,
                indexAxis: "y",
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        mode: "dataset",
                        intersect: true,
                        position: "average",
                        callbacks: {
                            label: (tooltipItem: TooltipItem<"bar">) =>
                            {
                                const value = tooltipItem.raw;
                                return `${value}%`;
                            },
                            title: (tooltips: Array<TooltipItem<"bar">>) =>
                            {
                                return tooltips[0].label;
                            },
                        },
                        backgroundColor: '#ffffff',
                        borderColor: '#767676',
                        borderWidth: 1
                    },
                },
                scales: {
                    x: {
                        stacked: true,
                        display: true,
                        grid: { display: true },
                        beginAtZero: true,
                        max: 100,
                        ticks: {
                            stepSize: 25,
                        },
                    },
                    y: {
                        stacked: true,
                        display: false,
                        grid: { display: false },
                    },
                },
            },
        };
    }
}
